// extracted by mini-css-extract-plugin
export var table = "_uy-0";